module.exports = __webpack_public_path__ + "media/images/idb_new_logo-70790aa1582a9277db3174a342c8ef25.png";